import { useCallback, useEffect, useRef, useState } from 'react';
import apiClient from '../services/apiClient';
import { createSceneSelectionRequestId, VOCABULARY_PRACTICE_TRIGGER } from '../services/SceneSelectionRequest';

// One optional introduction per page entry, shared by learning and daily review.
export default function useVocabularyEntryScene(session, ready) {
  const request = useRef(null);
  const [entry, setEntry] = useState({ sessionId: null, status: 'pending', scene: null });
  const sessionId = session?.id;
  const active = session?.status === 'active';

  useEffect(() => {
    if (!ready || !active || !sessionId) return undefined;
    if (request.current?.sessionId !== sessionId) {
      setEntry({ sessionId, status: 'pending', scene: null });
      const requestId = createSceneSelectionRequestId();
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      request.current = { sessionId, promise: Promise.resolve()
        .then(() => apiClient.getRandomScene({ trigger: VOCABULARY_PRACTICE_TRIGGER, timezone, requestId }))
        .then(result => result?.scene?.frames?.some(frame => typeof frame?.text === 'string' && frame.text.trim()) ? result.scene : null)
        .catch(error => { console.warn('Failed to load vocabulary entry scene:', error); return null; }) };
    }
    let cancelled = false;
    request.current.promise.then(scene => {
      if (!cancelled) setEntry(current => current.sessionId === sessionId && current.status !== 'pending'
        ? current : { sessionId, status: scene ? 'playing' : 'done', scene });
    });
    return () => { cancelled = true; };
  }, [active, ready, sessionId]);

  const complete = useCallback(() => setEntry(current => ({ ...current, status: 'done', scene: null })), []);
  return {
    blocked: Boolean(active && sessionId && (entry.sessionId !== sessionId || entry.status !== 'done')),
    scene: entry.sessionId === sessionId ? entry.scene : null,
    complete,
  };
}
